var map = {
	"./bignumbers/bignumbers.ts": 76082,
	"./chat-live-agent/chat-live-agent.ts": 89876,
	"./footer/footer.ts": 22036,
	"./form/file-upload.ts": 8734,
	"./form/form-tracking.ts": 39490,
	"./fullwidthhorizontalteaser/fullwidthhorizontalteaser.ts": 13404,
	"./horizontalteaser-v2/horizontalTeaser.ts": 90407,
	"./image/image.ts": 30912,
	"./image/responsiveimage/getAspectRatioFromHyphenizedString.ts": 3321,
	"./imagecarousel/imagecarousel.ts": 83916,
	"./imagecarousel/trackingUtils.ts": 5633,
	"./imagecarousel/zoomUtils.ts": 6371,
	"./news-teasers/news-teaser.ts": 87533,
	"./tagList/tagList.ts": 35920,
	"./teaserHeightAdjustment/teaserHeightAdjustment.ts": 81296,
	"./ts-component-registry.ts": 44038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22118;